import { render, staticRenderFns } from "./marksEntryIota.vue?vue&type=template&id=8f06b676&scoped=true&"
import script from "./marksEntryIota.vue?vue&type=script&lang=js&"
export * from "./marksEntryIota.vue?vue&type=script&lang=js&"
import style0 from "./marksEntryIota.vue?vue&type=style&index=0&id=8f06b676&lang=scss&scoped=true&"
import style1 from "./marksEntryIota.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksEntryIota.vue?vue&type=style&index=2&id=8f06b676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f06b676",
  null
  
)

export default component.exports